/*!
 *  (c)(r) 2008-2023 IT-Service Robert Frunzke
 */

import { startProgress, stopProgress } from './progress-util.js';
import { confirm_box, big_confirm_box } from './page-modal.js';
import { showInfoToast, showWarningToast } from './snackbar.js';
import { postToBackend } from './fetch-util.js';
import { mjt } from './i18ntexts.js';
import { mj } from 'js/entry/util.js';

import { MDMedia } from './media-data.js';
import { MVSearch } from './search.js';


let m_selection_changed_fn = null;


export function initMVMediaPageActions( selection_changed_fn ) {
	m_selection_changed_fn = selection_changed_fn;
}


export function delete_media( media_ids, deleted_callback, restored_callback ) {
	//if( !m_has_dom ) return;

	var _delete_media = function( media_ids, deleted_callback, restored_callback ) {
		var requested_length = media_ids.length;
		var remaining = media_ids.slice();
		var deleted = [];
		var deleted_token = [];
		remaining.reverse(); // actually delete assets in reverse order
		startProgress();
		var delete_next_batch = function _delete_next_batch() {
			// delete in batches (to avoid timeouts)
			var batch_size = 15;
			if( remaining.length>batch_size && remaining.length<Math.floor(batch_size/2) ) batch_size = Math.floor((remaining.length+1)/2);
			var delete_now = remaining.slice(0,batch_size);
			remaining.splice(0,batch_size);
			MDMedia.deleteMedia(
				delete_now,
				function( deleted_media_ids, all_data ) {
					for( var i=0; i<deleted_media_ids.length; ++i ) deleted.push(deleted_media_ids[i]);
					deleted_token.push(all_data['undo_token']);
					if( remaining.length===0 ) {
						// done
						stopProgress();
						var options = {
							undoToken: deleted_token,
							undoCallback: function() {
								if( m_selection_changed_fn ) {
									m_selection_changed_fn();
								}
								MDMedia.onAfterRestoreMedia(deleted_media_ids,function() {
									if( restored_callback ) restored_callback(deleted_media_ids);
									showInfoToast(mjt('info-media-delete-reverted'));
								} );
							}
						};
						if(!mj.restore_assets) options = {};
						if( deleted.length===1 && requested_length===1 ) showInfoToast( mjt('info-media-1-deleted'), options );
						else if( deleted.length===1 && requested_length>1 ) showInfoToast( mjt('info-media-1-deleted-but-more-requested'), options );
						else if( deleted.length>0 && deleted.length!==requested_length ) showInfoToast( mjt('info-media-deleted-but-more-requested'),options );
						else if( deleted.length===0 ) showInfoToast( mjt('info-media-deleted-none') );
						else showInfoToast( mjt('info-media-deleted'), options );

						if( deleted_callback ) deleted_callback(deleted);
						if( m_selection_changed_fn ) m_selection_changed_fn();
					} else {
						delete_next_batch();
					}
				},
				function(error_msg) {
					stopProgress();
					MVSearch.updateCategoryCounts();
					showWarningToast( 'delete failed: '+error_msg );
					if( deleted_callback ) deleted_callback(deleted);
					if( m_selection_changed_fn ) m_selection_changed_fn();
				},
				true
			);
		};
		delete_next_batch();
	};
	if( mj.restore_assets ) {
		_delete_media(media_ids,deleted_callback,restored_callback);
	} else {
		confirm_box( mjt('delete-media-title'), media_ids.length > 1 ? mjt('delete-media-message') : mjt('delete-media-message-1') , function() {
			_delete_media(media_ids,deleted_callback,restored_callback);
		});
	}
}


export function maintenance_post_import_media( media_ids ) {
	big_confirm_box( mjt('post-import-media-title'), mjt('post-import-media-message'), function() {
		startProgress();
		postToBackend( 'json/media/administration-post_import', 'media_ids='+media_ids.join(','), function(j) {
			if( j && j.success ) showInfoToast(mjt('post-import-media-success'));
			MDMedia.invalidateMediaCaches(media_ids);
			stopProgress();
		} );
	} );
}

export function maintenance_update_media( media_ids ) {
	big_confirm_box( mjt('media-update-media-title'), mjt('media-update-media-message'), function() {
		startProgress();
		postToBackend( 'json/media/administration-media_update', 'media_ids='+media_ids.join(','), function(j) {
			if( j && j.success ) showInfoToast(mjt('media-update-media-success'));
			MDMedia.invalidateMediaCaches(media_ids);
			stopProgress();
		} );
	} );
}

export function maintenance_re_import_media( media_ids ) {
	big_confirm_box( mjt('re-import-media-title'), mjt('re-import-media-message'), function() {
		startProgress();
		postToBackend( 'json/media/administration-re_import', 'media_ids='+media_ids.join(','), function(j) {
			if( j && j.success ) showInfoToast(mjt('re-import-media-success'));
			MDMedia.invalidateMediaCaches(media_ids);
			stopProgress();
		} );
	} );
}
